const fr_CA = {
  code: "fr-CA",
  language: {
    code: "fr",
    name: "Français (Canada)",
  },

  labels: {
    actions: "Actions",
    address: "Adresse",
    artifactBuilder: "Générateur d'artefacts",
    callDuration: "Durée de l’appel",
    callDurationEst: "Durée de l’appel (estimée)",
    callDurationOutliers: "Durées d’appel atypiques",
    call: "Appel",
    calls: "Appels",
    courierAddress: "Adresse de messagerie",
    clientPortals: "Portails client",
    clientPortalCatalog: "Catalogue des portails client",
    employeeNumber: "Numéro d'employé",
    expenses: "Dépenses",
    enter: "Entrer",
    error: "Erreur",
    failed: "Échoué",
    filters: "Filtres",
    finishedAt: "Terminé à",
    firstCall: "Premier appel",
    allowExpenses: "Autoriser les dépenses",
    hide: "Cacher",
    home: "Accueil",
    homeMileage: "Kilométrage domicile",
    isActive: "Actif",
    isMandatory: "Obligatoire",
    lastCall: "Dernier appel",
    lastSyncDate: "Dernière date de synchronisation",
    leave: "Quitter quand même",
    login: "Connexion",
    logout: "Déconnexion",
    messages: "Messages",
    mileage: "Kilométrage",
    moveable: "Déplaçables",
    mySchedule: "Mon horaire",
    next: "Suivant",
    noRepsAvailable: "Aucun représentant disponible",
    openMap: "Ouvrir la carte",
    baseUom: "Unité de base",
    unitsPerPack: "Unités par paquet",
    unitsPerCase: "Unités par caisse",
    prev: "Précédent",
    location: "Emplacement",
    latitude: "Latitude",
    longitude: "Longitude",
    password: "Mot de passe",
    pendingExpenseApprovals: "Dépenses en attente",
    pendingCallDurationOutliers: "Durées atypiques",
    adpConfiguration: "Configuration ADP",
    payReceipt: "Releve de paie",
    previousAnswer: "Réponse précédente",
    project: "Projet",
    projectType: "Type de projet",
    projects: "Projets",
    privacyPolicy: "Politique de confidentialité",
    qa: "Examen QA",
    reason: "Raison",
    reassignRepOptional: "Réassigner le représentant (optionnel)",
    rescheduled: "replanifiés",
    reassigned: "réassignés",
    and: "et",
    relativeDays: "Relatif (jours)",
    relativeDaysPlaceholder: "ex. 5 ou -3",
    redo: "Refaire la synchronisation précédente",
    reschedule: "Replanifier",
    rescheduleType: "Type de replanification",
    rescheduleTo: "Replanifier au :",
    reset: "Réinitialiser",
    resetDatabase: "Réinitialiser la base de données",
    role: "Rôle",
    supervisor: "Superviseur",
    teamLead: "Chef d'équipe",
    assignedProvinces: "Provinces assignées",
    schedule: "Horaire",
    scheduledLocations: "Emplacements planifiés",
    scheduledCalls: "Appels planifiés",
    scheduledLocationsEmpty:
      "Aucun emplacement planifié pour les filtres actuels",
    noLocationsWithCoordinates: "Aucun emplacement avec coordonnées disponible",
    searchLocationOrProject: "Rechercher un emplacement ou projet",
    selectAll: "Tout sélectionner",
    setToSpecificDate: "Définir à une date précise",
    adjustByDays: "Ajuster de (jours) :",
    adjustDaysHelperText:
      "Positif pour dates futures, négatif pour dates passées",
    settings: "Paramètres",
    show: "Afficher",
    startDate: "Début",
    endDate: "Fin",
    start: "Démarrer",
    startedAt: "Commencé à",
    stay: "Rester",
    success: "Succès",
    surveys: "Sondages",
    surveyPages: "Pages du sondage",
    supervisorCalendar: "Calendrier du superviseur",
    surveyQuestions: "Questions du sondage",
    surveySections: "Sections du sondage",
    surveyImages: "Images du sondage",
    syncReport: "Rapport de synchronisation",
    syncSupport: "Support de synchronisation",
    synchronization: "Synchronisation",
    syncing: "Synchronisation en cours....",
    syncType: "Type de synchronisation",
    syndication: "Diffusion",
    syndicatedTerritory: "Territoire syndiqué",
    syndicatedTerritories: "Territoires syndiqués",
    territories: "Territoires",
    territoryLocation: "Emplacement du territoire",
    today: "Aujourd’hui",
    applyChanges: "Appliquer les modifications",
    clear: "Effacer",
    failedCalls: "Appels échoués :",
    partialSuccess: "Succès partiel",
    closeMap: "Fermer la carte",
    mapFor: "Carte pour",
    of: "sur",
    unknown: "Inconnu",
    username: "Nom d’utilisateur",
    view: "Voir",
  },

  titles: {
    callActionSummary: "Résumé des actions d’appel",
    calls: "Appels",
    callsIncomplete: "Appels à compléter",
    callsToday: "Appels aujourd’hui",
    home: "Accueil",
    location_new: "Nouveau lieu",
    location_update: "Mettre à jour l'emplacement",
    schedule: "Mon horaire",
    scheduledLocations: "Emplacements planifiés",
    payroll: "Ma paie",
    surveyNav: "Navigation du sondage",
    surveys: "Sondages",
    sync: "Synchronisation",
    synchronization: "Synchronisation",
    syncSupport: "Support de synchronisation",
  },

  messages: {
    invalidCredentials: "Identifiants invalides",
    firstSync: "Cet appareil n’a pas encore été synchronisé.",
    selectAtLeastOneCall: "Veuillez sélectionner au moins un appel",
    selectRescheduleOrReassign:
      "Veuillez choisir une date/jours de replanification ou un représentant à réassigner",
    unableToLoadCallDetails: "Impossible de charger les détails de l’appel",
    errorProcessingCalls: "Erreur lors du traitement des appels : {error}",
    allCallsActionSuccess:
      "Tous les appels ({count}) ont été {actions} avec succès",
    partialCallsActionSuccess:
      "{successCount} sur {totalCount} appels ont été {actions} avec succès. {errorCount} ont échoué en raison des restrictions de blackout ou d’autres problèmes.",
    allCallsActionFailed:
      "Tous les appels ({totalCount}) ont échoué à être {actions}.",
    unexpectedResult: "Résultat inattendu du serveur",
    missingCallInformation:
      "L’appel est incomplet. Veuillez compléter tous les éléments en suspens pour le paiement.\n\nVoulez-vous quitter quand même?",
    missingMileage: "Requis pour le remboursement!",
    missingOptionalSurvey: "Sondage facultatif non rempli.",
    missingRequiredSurvey: "Sondage requis pour le paiement!",
    notAnswered: "non répondu",
    requiredForPayment: "Requis pour le paiement!",
    selectSyncRecord: "Sélectionner une date",
    startFinishRequired:
      "Les heures de début et de fin sont requises pour le paiement. Voulez-vous quitter quand même?",
    sync_answers: "Réponses",
    sync_banners: "Bannières",
    sync_callresults: "Résultats d’appel",
    sync_calls: "Appels",
    sync_clients: "Clients",
    sync_downloadStarting: "Téléchargement en cours...",
    sync_downloadComplete: "Téléchargement terminé!",
    sync_error: "ERREUR de synchronisation $tableName",
    sync_finish: "Synchronisation terminée!",
    sync_listings: "Listes",
    sync_locations: "Emplacements",
    mapSelected: "Carte Sélectionnés",
    mapLocation: "Carte Emplacement",
    mappingLocations: "Cartographie {count} de {total} emplacements",
    sync_pages: "Pages du sondage",
    sync_processingDownload: "Traitement du téléchargement...",
    sync_projects: "Projets",
    sync_questions: "Questions du sondage",
    sync_retailers: "Détaillants",
    sync_sections: "Sections du sondage",
    sync_schema: "Changements de base de données",
    sync_skus: "UGS",
    sync_start: "Démarrage de la synchronisation...",
    sync_stopping: "ARRÊT.....",
    sync_surveys: "Sondages",
    sync_syndication: "Diffusion",
    sync_variability: "Variabilité",
    sync_uploadStarting: "Téléversement en cours...",
    sync_uploadComplete: "Téléversement terminé!",
  },

  lists: {
    syncTypes: [
      { id: "manual", name: "Manuel" },
      { id: "auto", name: "Automatique" },
    ],
  },

  reports: {
    callSummary: {
      title: "Call Summary",
      width: "620px",
      columns: [
        {
          name: "name",
          label: "project",
          width: "200px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px", fontWeight: "bold" },
          clickable: true,
        },
        {
          name: "incomplete",
          label: "Incomplete",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
        {
          name: "today",
          label: "Today",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
        {
          name: "tomorrow",
          label: "Tomorrow",
          width: "35px",
          labelStyle: { fontSize: "12px" },
          style: { fontSize: "12px" },
          textAlign: "center",
          clickable: true,
        },
      ],
      allowSort: false,
    },
  },

  calendarLists: {
    dow: [
      { id: "sun", name: "Dimanche" },
      { id: "mon", name: "Lundi" },
      { id: "tue", name: "Mardi" },
      { id: "wed", name: "Mercredi" },
      { id: "thu", name: "Jeudi" },
      { id: "fri", name: "Vendredi" },
      { id: "sat", name: "Samedi" },
    ],
    weekdays: [
      { id: 0, name: "Dimanche", short: "Dim", letter: "D" },
      { id: 1, name: "Lundi", short: "Lun", letter: "L" },
      { id: 2, name: "Mardi", short: "Mar", letter: "M" },
      { id: 3, name: "Mercredi", short: "Mer", letter: "M" },
      { id: 4, name: "Jeudi", short: "Jeu", letter: "J" },
      { id: 5, name: "Vendredi", short: "Ven", letter: "V" },
      { id: 6, name: "Samedi", short: "Sam", letter: "S" },
    ],
    months: [
      { id: "0", name: "Janvier", short: "Jan" },
      { id: "1", name: "Février", short: "Fév" },
      { id: "2", name: "Mars", short: "Mar" },
      { id: "3", name: "Avril", short: "Avr" },
      { id: "4", name: "Mai", short: "Mai" },
      { id: "5", name: "Juin", short: "Jun" },
      { id: "6", name: "Juillet", short: "Jul" },
      { id: "7", name: "Août", short: "Aoû" },
      { id: "8", name: "Septembre", short: "Sep" },
      { id: "9", name: "Octobre", short: "Oct" },
      { id: "10", name: "Novembre", short: "Nov" },
      { id: "11", name: "Décembre", short: "Déc" },
    ],
  },

  types: {
    callStatus: {
      future: { name: "Future", color: "#ccc" },
      incomplete: { name: "Incomplete", color: "#ff0000" },
      complete: { name: "Complete", color: "#00ff00" },
      expired: { name: "Expired", color: "#ff9800" },
    },
    imageResolution: [
      { id: "high", name: "High Definition" },
      { id: "medium", name: "Medium Definition" },
      { id: "low", name: "Low Definition" },
    ],
    imageNumber: [
      { id: "single", name: "Single Image" },
      { id: "multiple", name: "Multiple Images" },
    ],
    imageType: [
      { id: "standard", name: "Standard" },
      { id: "beforeAfter", name: "Before & After" },
    ],
    previousAnswerTypes: [
      { id: "na", name: "Not Applicable" },
      { id: "initialize", name: "Initialize with Value" },
      { id: "show", name: "Show Value" },
    ],
    pricingRetailLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
    ],
    pricingCountryLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "provincial", name: "Provincial" },
    ],
    listingRetailLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
      { id: "location", name: "Location" },
    ],
    listingCountryLevels: [
      { id: "not-set", name: "Not Set" },
      { id: "national", name: "National" },
      { id: "provincial", name: "Provincial" },
    ],
    questionTypes: [
      { id: "text", name: "Text" },
      { id: "number", name: "Number" },
      { id: "currency", name: "Currency" },
      { id: "date", name: "Date" },
      { id: "time", name: "Time" },
      { id: "select", name: "Select" },
      { id: "checkbox", name: "Checkbox" },
      { id: "radio", name: "Radio" },
      { id: "image", name: "Image" },
      { id: "multiselect", name: "Multi-Select" },
      { id: "signature", name: "Signature" },
      { id: "informational", name: "Informational" },
      { id: "distribution", name: "Distribution" },
      { id: "variability", name: "Variability" },
    ],
    sectionTypes: [
      { id: "question", name: "Question" },
      { id: "sku", name: "SKU" },
      { id: "text", name: "Text" },
    ],
    visibilityFilters: [
      { id: "retailer", name: "Retailer" },
      { id: "banner", name: "Banner" },
      { id: "province", name: "Province" },
    ],
  },

  provinces: [
    { id: "BC", name: "British Columbia" },
    { id: "AB", name: "Alberta" },
    { id: "SK", name: "Saskatchewan" },
    { id: "MB", name: "Manitoba" },
    { id: "ON", name: "Ontario" },
    { id: "QC", name: "Quebec" },
    { id: "NB", name: "New Brunswick" },
    { id: "NS", name: "Nova Scotia" },
    { id: "NL", name: "Newfoundland and Labrador" },
    { id: "PE", name: "Prince Edward Island" },
    { id: "NT", name: "Northwest Territories" },
    { id: "YT", name: "Yukon" },
    { id: "NU", name: "Nunavut" },
  ],

  distribution: {
    questionText: {
      availableForSale:
        "UPON ENTRY is this sku available for sale in this store? (tag & product)",
      actionTaken:
        "ACTON TAKEN BEFORE EXITING THE STORE - If not in distribution what action did you take to get this product into distribution?",
      followUpQuestions: {
        why_tag_not_placed: "Why was tag not placed?",
        why_tag_not_on_shelf: "Why was tag not on shelf?",
        why_not_on_pog: "Why not on POG?",
      },
    },
    availableForSale: [
      { id: "1", name: "YES" },
      { id: "0", name: "NO" },
    ],
    actionTaken: [
      { id: "placedTagandProduct", name: "I placed tag & product" },
      {
        id: "tag-NoBackroomAccess",
        name: "Tag in place, no access to backroom",
      },
      { id: "tag-ProductOrdered", name: "Tag in place, product ordered" },
      { id: "noTag-ProductOnShelf", name: "No tag, product on shelf" },
      {
        id: "noTag-NoProduct-ProductOrdered",
        name: "No tag, no product - Product ordered or in transit",
      },
      { id: "planogramNotCompleted", name: "New planogram not completed" },
    ],
    followUpOptions: {
      why_tag_not_placed: [
        { id: "will_print_later", name: "Will print later" },
        { id: "other", name: "Other" },
      ],
      why_tag_not_on_shelf: [
        { id: "will_print_arrival", name: "Will print when product arrives" },
        { id: "other", name: "Other" },
      ],
      why_not_on_pog: [
        { id: "will_renew_pog", name: "Will renew POG" },
        { id: "not_on_pog", name: "Not on POG" },
        { id: "section_too_small", name: "Section too small" },
        { id: "product_no_sell", name: "Product does not sell well" },
        { id: "other", name: "Other" },
      ],
    },
  },

  outofstock: {
    questionText: {
      productOnShelfOnEntry: "Was there product upon ENTRY?",
      productAdded: "Did you add product?",
    },
    productOnEntry: [
      { id: "true", name: "YES product upon ENTRY" },
      { id: "false", name: "NO product upon ENTRY" },
    ],
    productAdded: [
      { id: "true", name: "YES, product was added" },
      { id: "false", name: "NO, product NOT added" },
    ],
  },
};

export default fr_CA;
